export enum AuthModuleSections {
    signIn = 'signIn',
    signUp = 'signUp',
    passwordRestore = 'passwordRestore',
    creatingPassword = 'create-password',
}
